// FP3-072 — Help Center contextual link (Jun 8, 2026).
//
// Tiny "Learn more" link that deep-links into a Help Center article
// via URL hash. The Help Center page (`/help`) auto-opens the
// matching accordion and scrolls it into view on hashchange.
//
// Keep it small. Default rendering: a short, inline "Learn more"
// link with a Question icon. Override via `label` prop when a
// different verb fits (e.g. "How this works").

import { Link } from "react-router-dom";
import { Question } from "@phosphor-icons/react";

export default function HelpLink({
  articleId,
  label = "Learn more",
  testId,
  className = "",
  iconSize = 12,
}) {
  return (
    <Link
      to={`/help#${articleId}`}
      data-testid={testId || `help-link-${articleId}`}
      className={`inline-flex items-center gap-1 text-[11.5px] text-[#1E3F33] hover:text-[#173127] hover:underline underline-offset-2 transition-colors ${className}`}
    >
      <Question size={iconSize} weight="bold" aria-hidden="true" />
      <span>{label}</span>
    </Link>
  );
}
